import { LitEntity, html, css } from '../../utility/lit-entity';
import { sharedStyles } from '../../styles/shared-styles';
import '../../common/bn-loading';

class OrganizationDropdownList extends LitEntity {
  static get properties() {
    return {
      dest: { type: String },
      organizations: { type: Array },
      open: { type: Boolean, reflect: true },
    };
  }

  static get styles() {
    return [sharedStyles, css`
      :host {
        display: inline-block;
        position: absolute;
        left: 2em;
        border: 1px solid var(--gray-50);
        box-shadow: 1px 1px 2px rgba(0,0,0,.1);
        background-color: var(--surface);
        box-sizing: border-box;
        overflow-y: auto;
        overflow-x: hidden;
        text-overflow: ellipsis;
        max-height: 20em;
        min-width: 100px;
        max-width: var(--dropdown-width, 300px);
        z-index: 1000;
      }
      ul {
        margin: 0;
        padding: 0;
        list-style-type: none;
      }
      li {
        margin: 1px;
        padding: 0;
      }
      a {
        display: block;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        padding: 6px 12px;
        text-decoration: none;
      }
      a:hover {
        background-color: var(--blue-10);
        color: var(--blue-60);
      }
      .no-data {
        padding: 6px 12px;
        font-size: .8em;
        color: var(--gray-70);
      }
      bn-loading {
        margin: .5em 3em;
      }
    `];
  }

  render() {
    if (this.loading) {
      return html`<bn-loading></bn-loading>`;
    }
    return html`
      <ul class="dropdown">
        ${this._renderOrgs()}
      </ul>
    `;
  }

  _renderOrgs() {
    if (!this.organizations.length) {
      return html`<li class="no-data">No sub-organizations to display</li>`;
    }
    return html`
      ${this.organizations.map((org) => html`
        <li>
          <a
            href="${this._organizationLinkHref(org)}"
            title="${org.properties.name}"
            @click="${() => this.dispatchEvent(new CustomEvent('organizationclicked', { detail: { organization: org } }))}"
          >
            ${org.properties.name}
          </a>
        </li>
      `)}
    `;
  }

  _organizationLinkHref(org) {
    return this.dest ? `${this.dest}?orgId=${encodeURIComponent(org.getLinkByRel('self').href)}` : 'javascript:void(0)';
  }

  _entityChanged(entity) {
    super._entityChanged(entity);
    this.organizations = this.organizations || (this.entity && this.entity.getSubEntitiesByClass('organization')) || [];
  }
}

window.customElements.define('organization-dropdown-list', OrganizationDropdownList);
